/**
 * @param {Array<String>} массив результатов
 * @param {Number} текущее значение
 * @returns {String} результат
 */

export const getPluralString = (valueArray, evaluation) => {
  let idx
  if (evaluation % 10 === 1 && evaluation % 100 !== 11) {
    idx = 0
  } else if (evaluation % 10 >= 2 && evaluation % 10 <= 4 && (evaluation % 100 < 10 || evaluation % 100 >= 20)) {
    idx = 1
  } else {
    idx = 2
  }

  return valueArray[idx]
}

export default getPluralString
